import { makeStyles, createTheme } from '@material-ui/core/styles';
// @ts-ignore
import createNcrRetailTheme, { themeColors } from '@ncr-retail/mui-theme';
var theme = createTheme(createNcrRetailTheme());
var themeColor = themeColors();
var rippleStyles = makeStyles({
    containedButton: {
        color: themeColor.white,
        border: 'none!important',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.05)!important',
        '&.Mui-disabled': {
            borderRadius: '2px',
            boxShadow: "0px 1px 2px " + themeColor.verylightgrey + " !important",
            backgroundColor: theme.palette.primary.main + " !important",
            '&>span': {
                opacity: 0.4,
                color: themeColor.white + "!important",
            },
        },
    },
    containedBorderButton: {
        color: themeColors.white,
        border: "1px solid " + themeColor.lightgrey,
        boxSizing: 'border-box',
        boxShadow: "0px 1px 2px " + themeColor.verylightgrey,
        borderRadius: '2px',
    },
    textButton: {
        backgroundColor: themeColor.white + "!important",
        color: theme.palette.secondary.main + "!important",
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.05)!important',
        '&>span': {
            color: '#666666!important',
        },
        '&:active': {
            '&>span': {
                color: themeColor.black + " !important",
            },
            boxShadow: 'none!important',
        },
        '& span[class^="MuiTouchRipple"]': {
            color: theme.palette.secondary.main + "!important",
        },
        '&:hover': {
            backgroundColor: themeColor.white,
            boxShadow: 'none!important',
        },
        '&.Mui-disabled': {
            backgroundColor: themeColor.white,
            '& *': {
                color: 'rgba(3, 6, 30, 0.2)!important',
                fill: 'rgba(3, 6, 30, 0.2)!important',
            },
        },
    },
    actionsButton: {
        backgroundColor: themeColor.verylightgrey + " !important",
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.05)!important',
        color: theme.palette.secondary.main + "!important",
        '&>span': {
            color: '#666666!important',
        },
        '&>span[class^="MuiTouchRipple-root"]': {
            color: theme.palette.secondary.main + "!important",
        },
        '&:hover': {
            backgroundColor: themeColor.verylightgrey + " !important",
            boxShadow: 'none!important',
        },
        '&:active': {
            boxShadow: 'none!important',
        },
        '&.Mui-disabled': {
            boxShadow: 'none!important',
        },
    },
    specialContainedButton: {
        color: 'rgba(255,255,255,0.3)!important',
    },
});
export default rippleStyles;
